import { useEffect, useLayoutEffect, useState } from "react";
import Loading from "./_Loading";
import NoFilesCell from "./_NoFilesCell";
import TablePagination from "./_TablePagination";

export default function Table({cvmCode, categoryID, documentID}) {
    const [loading, setLoading] = useState(true);
    const [filings, setFilings] = useState([]);

    const [page, setPage] = useState(1);
    const itemsPerPage = 10;

    const updateTablePage = function(toPage) {
        setPage(toPage);
    }

    const verifiqCategory = function(category,document){
        if(category == null){
            return '/documents?document=' + document
        } else {
            return '/documents?category=' + category
        }
    }

    useEffect(() => {
        
        const url = 'https://api.mziq.com/mzfilemanager/company/' + cvmCode + verifiqCategory(categoryID, documentID);
        
        fetch(url).then(body => {
            body.json().then(res => {
                /** @type {Array} */
                const docs = res.data.filter(filing => filing.id_categoria === categoryID);
    
                // docs.sort(function (a, b) {
                //     return new Date(a.data_download) - new Date(b.data_download);
                // });

                docs.reverse();
                
                setLoading(false);
                setFilings(docs);
            })
        }).catch(err => console.error('TABLE ERROR', err));
    }, [page]);

    if(filings.length === 0 && !loading) {
        return <table className="pageCVM__files">
            <tbody>
                <NoFilesCell categoryID={categoryID} />
            </tbody>
        </table>;
    }

    return (
        <table className="pageCVM__files">
            <tbody>
                {loading === true && (
                    <tr>
                        <td colSpan={3}><Loading isLoading={loading} /></td>
                    </tr>
                )}
                {filings.slice(itemsPerPage * (page - 1), itemsPerPage * page).map(filing => {
                    const date = new Date(filing.data_referencia);
                    const dateFull = date.toLocaleString(lang, {timeZone: 'UTC', dateStyle: 'short'});

                    return <tr key={`${filing.documento}_${filing.id_arquivamento}_${filing.id_categoria}_${filing.id_documento}`}>
                        <td className="pageCVM__singleFile name">
                            <span>{filing.nome_amigavel}</span>
                        </td>

                        <td className="pageCVM__singleFile date pl-3 pl-xl-5">
                            <span>{dateFull}</span>
                        </td>

                        <td className="pageCVM__singleFile download pl-3 pl-xl-5">
                            <a href={filing.url_cvm} target="_blank">
                                <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 13L15 9M11 13V1V13ZM11 13L7 9L11 13Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M1 15L1.621 17.485C1.72915 17.9177 1.97882 18.3018 2.33033 18.5763C2.68184 18.8508 3.11501 18.9999 3.561 19H18.439C18.885 18.9999 19.3182 18.8508 19.6697 18.5763C20.0212 18.3018 20.2708 17.9177 20.379 17.485L21 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>                            
                            </a>
                        </td>
                    </tr>;
                })}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={3}>
                        <TablePagination
                            itemsPerPage={itemsPerPage}
                            amount={filings.length}
                            currentPage={page}
                            updateTablePage={updateTablePage}
                        />
                    </td>
                </tr>
            </tfoot>
        </table>
    );
}